(ns pfo.document.component
  (:require
   #_:clj-kondo/ignore [taoensso.timbre :as timbre
                        :refer [log trace debug info warn error fatal report logf
                                tracef debugf infof warnf errorf fatalf reportf spy]]
    [clojure.string :as str]
    [goog.string :refer [format endsWith]]
    [reagent.core :as reagent :refer [atom track!]]
    [reagent.ratom :refer-macros [run! reaction]]
    [reagent.session :as session]
    [lentes.core :as l]
    [pfo.collection.model :as collection-model :refer [collection-key]]
    [pfo.flag :refer [enabled]]
    ;; [pfo.collection.component :as collection-component]
    [pfo.category.model :as category-model]
    [pfo.category.component :refer [category-chooser]]
    [pfo.controller :as controller :refer [subscribe]]
    [pfo.common.model :as common-model :refer [document-complex-name with-complex-names]]
    [pfo.document.model :as model]
    [pfo.staging.workspace :as staging-workspace]
    [pfo.auth.model :as auth-model :refer [perm has-perm-in-any-family]]
    [pfo.link.component :as link]
    [pfo.link.model :as link-model]
    [pfo.scope.scope :as scope :refer [scope level-family]]
    [pfo.task.model :as task-model]
    [pfo.common.component :refer [sidebar sidebar-rounded header date-filter header-tab-wrapper filter-exclude mobile?] :as common]
    [pfo.comment.component :as comment-comp]
    [pfo.assignment.component :refer [assignments-add-new assignments-table
                                      assignments-edit-notable-redesign
                                      collection-field-header
                                      assignments-add-new-notable
                                      get-initial-ui-assignments get-collection-ids
                                      assignment-list assignment-list-with-header
                                      group-chooser
                                      set-assignment
                                      collection-name]]
    [pfo.widget.help :refer [help-popover]]
    [pfo.widget.tabs :refer [tab-header]]
    [pfo.widget.paginator :refer [paginator tfoot-paginator]]
    [pfo.widget.modal :refer [modal]]
    [pfo.widget.pdf :refer [pdf-view]]
    [pfo.widget.image :refer [image-view]]
    [pfo.widget.select :refer [nested-select default-select-sizer]]
    [pfo.widget.list :refer [orderer]]
    [pfo.widget.editor :refer [editor]]
    [pfo.widget.countdown :refer [countdown-for-ability]]
    [pfo.flash :refer [set-flash]]
    [pfo.form :as form :refer [reset-choice set-selected option-value unselect-if-no-value]]
    [pfo.util :as util :refer [handler reset-from-event str->int set-location split-string] :rename {split-string split}]
    [pfo.state :as state :refer [ui-state]]
    [pfo.valid :as valid]
    [pfo.api :as api :refer [process-error handle-error-response]]
    [pfo.time :as time :refer [now now-js-date now-millis ceil is-now-within-window]]
    [cljs-time.core :as time-core]
    [dommy.core :as dommy :refer-macros [sel sel1]]
    [promesa.core :as p]
    [secretary.core :as secretary]
    [pfo.chat.common-component :as chat-common]
    [pfo.widget.autocomplete :refer [react-select-styles]]
    [pfo.revroutes :refer [path-for]]
    [pfo.tz :as tz]
    ["react-select" :default Select]
    ["react-dropzone-component" :default ReactDropzone]))

(declare date-string dropzone document-submit pdf-preview document-filter pdf-placeholder is-image upload)

(def document-max-manage-age (time-core/minutes 15))

(def catom clojure.core/atom)
(def $ js/$)

(defn document-list-buttons [collection-id filter-show can-add?]
  [:span
   (when can-add?
     [:button {:on-click #(set! (.-location js/window)
                            (str "#/document/add/?collection_id=" collection-id))}
      "Add document"]) " "
   [:button {:on-click (util/handler #(swap! filter-show not))} "Filter"]])

(def document-icon-classes
    {"bmp" "image"
     "gif" "image"
     "heic" "image"
     "jpeg" "image"
     "jpg" "image"
     "png" "image"
     "svg" "image"
     "tiff" "image"
     "tif" "image"
     "pdf" "pdf"
     "text" "text"})

(defn get-url-ui-state [] (some-> (:document-filter (util/get-location-params)) (util/base64-url-unmarshal)))
(defn ui-state-value [akey]
  (or (akey (get-url-ui-state)) ((keyword (str "document-filter-" (name akey))) @ui-state)))

(defn document-thumbnail [doc thumbnail-preview-id show-tooltip]
  (let [document-url "/download/documents/"
        tooltip-component (atom nil)
        tooltip-width (atom nil)]
    (fn []
      [:a.tooltip-item
       {:href (str "#/document/details/" (:id doc))
        :ref (fn [comp]
               (when-let [sidebar-component (first (filter #(dommy/has-class? % "sidebar") (dommy/ancestors comp)))]
                 (reset! tooltip-width (* 0.8 (.-offsetWidth sidebar-component)))))
        :on-mouse-over (util/handler #(when show-tooltip (reset! thumbnail-preview-id (:id doc))))
        :on-mouse-out (util/handler #(when show-tooltip (reset! thumbnail-preview-id nil)))}
       (document-complex-name doc)
       (when (and (:is_pdf doc) (= (:id doc) @thumbnail-preview-id))
         [:div.tooltip {:ref (fn [comp] (reset! tooltip-component comp))
                        :style (merge
                                 {:visibility :hidden}
                                 (when @tooltip-width
                                   {:width (str @tooltip-width "px")}))}
          [pdf-view {:pdf-location {:url document-url
                                    :key (:download_key doc)}
                     :placeholder pdf-placeholder
                     :rendered-cb (fn []
                                    (when @tooltip-component
                                      (dommy/set-style! @tooltip-component "visibility" "visible")))}]])
       (when (and (is-image doc) (= (:id doc) @thumbnail-preview-id))
         [:div.tooltip.note (when @tooltip-width {:width (str @tooltip-width "px")})
          [image-view document-url (:download_key doc) {:attachment :no}]])
       (when (and (= (model/document-type doc) :note) (= (:id doc) @thumbnail-preview-id))
         [:div.tooltip (when @tooltip-width {:style {:width (str @tooltip-width "px")}})
          (util/html-elem :div.c-document__preview.is-list.is-doc.ql-editor (:body doc))])])))

(defn document-list [options collection-id documents filter-show]
  (let [choose (:choose options)
        chosen-documents (atom #{})
        orderer (if (:disable-ordering options) (fn [_ label _] label) orderer)
        select-all (atom false)
        checked? (fn [id] ((if @select-all not identity) (contains? @chosen-documents id)))
        documents (atom documents)
        num-selected (fn [] (if @select-all
                              (- (:count @documents) (count @chosen-documents))
                              (count @chosen-documents)))
        get-documents-id-map (fn [docs] (into {}  (mapv (fn [doc] [(:id doc) doc]) docs)))
        documents-id-map (catom (get-documents-id-map (:results @documents)))
        current-page (atom (or (:page options) (ui-state-value :page) 1))
        has-filtered-objects (track! (fn [] (:has_filtered_objects @documents)))
        has-parent-filtering (track! (fn [] (not (nil? (:has_filtered_objects @documents)))))
        filter-params (atom {;; When linking existing document, parent's collection ids are the limit
                             :collection-id (or (:choose-collection-ids options) collection-id (ui-state-value :collection-id))
                             :include-subcollections (cond
                                                       (:no-include-subcollections options) false
                                                       choose true
                                                       :else (or @state/include-descendants (:document-filter-include-subcollections @ui-state)))
                             :include-linked-to-other-parents nil
                             :period (ui-state-value :period)
                             :period-exclude (ui-state-value :period-exclude)
                             :collection-types (set (ui-state-value :collection-types))
                             :collection-types-exclude  (ui-state-value :collection-types-exclude)
                             :categories (set (ui-state-value :categories))
                             :categories-exclude (ui-state-value :categories-exclude)
                             :creator-users (into #{} (ui-state-value :creator-users))
                             :creator-users-exclude (ui-state-value :creator-users-exclude)
                             :created-at-period (ui-state-value :created-at-period)
                             :created-at-period-exclude (ui-state-value :created-at-period-exclude)})
        _ (dorun (map (partial common/disable-exclude-on-unselect! filter-params)
                   [[:period :period-exclude]
                    [:categories :categories-exclude]
                    [:collection-types :collection-types-exclude]
                    [:creator-users :creator-users-exclude]
                    [:created-at-period :created-at-period-exclude]]))
        filter-show (or filter-show (atom false))
        order (atom "-created_at")
        thumbnail-preview-id (atom nil)
        load-documents (fn [page]
                         (reset! current-page page)
                         (->> ((if (:collection-assignable-only options) model/collection-assignable-document-list model/document-list)
                               (when (:collection-assignable-only options)
                                 (merge
                                   (when (:paginate options) {:paginate true})
                                   {:current (:current options)
                                    :deleted (:deleted options)
                                    :image (:image options)}))
                               @current-page @order
                               @filter-params
                               (:choose-parent options))

                           (p/map (fn [documents-response]
                                    (reset! documents documents-response)
                                    (swap! documents-id-map merge (get-documents-id-map (:results documents-response)))))
                           (process-error)))]
    (when-not (:hide-filter @ui-state)
      (when (some util/pytrue?
              (concat
                [(when (not= (:include-subcollections @filter-params) @state/include-descendants)
                   (:include-subcollections @filter-params))]
                (vals
                  (select-keys @filter-params
                    [:period
                     :collection-types
                     :categories
                     :creator-users
                     :created-at-period]))))
        (reset! filter-show true)))

    (add-watch state/include-descendants
      :include-descendants-documents
      (fn [& _]
        (swap! filter-params assoc :include-subcollections @state/include-descendants)))

    (add-watch order :changed-order #(load-documents @current-page))

    (add-watch filter-params :document-filter-params (partial util/diff-watch (fn [& _] (load-documents @current-page))))

    (run!
      (let [list-state (merge @filter-params {:page @current-page})]
        (when-not (:choose-collection-ids options)
          ;; Only reset set URL data if it's not a linking flow
          (util/set-location-params {:document-filter (util/base64-url-marshal list-state)}))
        (swap! ui-state merge
          ;; Convert into :document-filter-* format
          (into {} (map (fn [[k v]] [(keyword (str "document-filter-" (name k))) v] ) list-state)))))

    (when-not @documents
      (load-documents 1))
    (reagent/create-class
      {:reagent-render
       (fn [options _]
         @chosen-documents ;; not sure why the reference in (when choose ...) is not enough to cause rerender on change
         @thumbnail-preview-id
         [:div.o-main-aside

          [:div.c-document-list.o-main-aside__main

           (when choose
             [:div.c-document-list__controls.o-media--bottom-shadow
              [:button.back {:on-click util/back} "Back"]
              [:button {:on-click (util/handler #(swap! filter-show not))} "Filter"]

              (when @has-filtered-objects
                [:span.error "List of documents displayed has been filtered to show only documents not yet linked in this workflow."])


              (when (not (zero? (num-selected)))
                [:button.save {:on-click (fn [] ((:choose-cb options)
                                                 (mapv #(@documents-id-map %) @chosen-documents)
                                                 (model/get-filter-api-params @filter-params)
                                                 @select-all))} "Save"])])

           [:> Select
            (merge
              {:isMulti true
               :value (if @select-all
                        {:value nil :label (str (num-selected) " document(s) selected")}
                        (map (fn[doc-id]{:value doc-id :label (document-complex-name (@documents-id-map doc-id) true) }) @chosen-documents))
               :className (when (zero? (num-selected)) :u-display--none)
               :placeholder nil
               :clearable false
               :components (clj->js {:Menu (fn [] nil)
                                     :Input (fn [] nil)
                                     :IndicatorSeparator (fn [] nil)
                                     :DropdownIndicator (fn [] nil)
                                     :ClearIndicator (fn [] nil)
                                     :MultiValueRemove (fn [] nil)})}
              (:second react-select-styles))]
           (:choose-extra-component options)


           (if (seq (:results @documents))
             [:table.documents.t-table-redesign {:class (when choose "choose")}
              [:thead
               [:tr
                [:th.assignments (orderer order "Collections" "collection_name")]
                [:th.icon]
                [:th.name (orderer order "Name" "complex_name")]
                [:th.date (orderer order "Applies To" "date")]
                (when choose
                  [:th.choose
                   (when-not (:single-document options)
                     [:span
                      [:a {:href "#"
                           :on-click (util/handler
                                       (fn []
                                         (reset! select-all true)
                                         (reset! chosen-documents #{})))} "All"] " | "
                      [:a {:href "#"
                           :on-click (util/handler
                                       (fn []
                                         (reset! select-all false)
                                         (reset! chosen-documents #{})))} "None"]])])]]
              [:tbody
               (doall
                 (for [doc (:results @documents)]
                   [:tr {:key (model/document-key doc)
                         :class (when (checked? (:id doc)) "selected")}
                    [:td.assignments [assignment-list (:document_collections doc)]]
                    [:td.icon [:span.icon {:class (document-icon-classes (:extension doc) "text")}]]
                    [:td.name [document-thumbnail doc thumbnail-preview-id true]
                     (when (> (:comment_count (:counters doc)) 0) [:span " " [:span.comment-count (:comment_count (:counters doc))]])]
                    [:td.date (date-string (:date_info doc))]
                    (when choose
                      [:td.choose.u-text-align-center [:input (form/set-checked (checked? (:id doc))
                                                                (merge
                                                                  {:on-change (fn [ev]
                                                                                (some-> (:choice-changed-cb options) (apply nil))
                                                                                (if ((if @select-all not identity) (form/checked? ev))
                                                                                  (if (:single-document options)
                                                                                    (reset! chosen-documents #{(:id doc)})
                                                                                    (swap! chosen-documents conj (:id doc)))
                                                                                  (swap! chosen-documents disj (:id doc))))}))]])]))]
              [tfoot-paginator

               [paginator
                (map (fn [page-number]
                       {:number page-number
                        :on-click (handler (fn [] (load-documents page-number)))})
                     (:page_numbers @documents))
                @current-page
                (when (:has_previous @documents) (handler #(load-documents (- @current-page 1))))
                (when (:has_next @documents) (handler #(load-documents (+ @current-page 1))))] 
               (if choose 5 4)
               (-> (:page_numbers @documents) count (> 1))]]

             [:p.o-media--bottom-shadow "No documents."])]


         (when @filter-show
           [document-filter
            {:show-collection-filter (not (boolean (:choose-collection-ids options)))
             :show-include-subcollections (:allow-subcollections options true)
             :collection-top-ancestor-id collection-id
             :has-filtered-objects @has-filtered-objects
             :has-parent-filtering @has-parent-filtering}
            filter-params filter-show])])})))

(defn main-document-list [options documents]
  (fn []
    (let [filter-show (atom false)]

      [:div
       ;; Reviewers also see an "Unfiled" tab leading to the staged-document
       ;; review workspace (#2851). The tab bar is shared with that workspace.
       (when (auth-model/can-access-document-review?)
         [staging-workspace/documents-page-tabs :all])
       [common/header-tab-wrapper
        [:span [:img.tab-header {:src "/static/img/icons/document-blue.svg"}] "Documents"]
        [document-list options nil documents filter-show]
        (if-not (:hide-filter @ui-state) [document-list-buttons nil filter-show (has-perm-in-any-family :can_add_document)] [:button {:on-click util/back} "Back"] )]])))

(defn date-string [{year :year month :month quarter :quarter day :day}]
  (if (not-empty year)
    (if (not-empty month)
      (let [month-str (str month (if (> (count month) 3) "." ""))]
        (if (not-empty day)
          (str month-str " " day ", " year)
          (str month-str " " year)))
      (if (not-empty quarter)
        (str quarter " " year)
        year)) ""))

(defn document-edit-form [{:keys [on-submit
                                  register-submit-action-fn]
                           :as options} collection document parent permitted-groups]
  (let [errors (atom {})
        group (atom (:id (first permitted-groups)))
        scope-atom (track! (fn [] (scope level-family @group)))
        allow-group-choice (and (not (:disable-group-choice options)) (not (:disable-collection-choice options)) (and (not parent) (> (count permitted-groups) 1)))
        allow-collection-choice (and (not (:disable-collection-choice options)) (not parent))

        document-type (atom (or (model/document-type document) :document))
        upload-id (atom (:upload-id options))
        name (atom (or (:name document) ""))
        ext-ref (atom (:ext_ref document))
        body (atom (or (:body document) nil))
        category (atom (:category_id document))

        year (atom (if-let [year (:year document)] (str year) "0"))
        month (atom (if-let [month (:month document)] (str month) "0"))
        day (atom (if-let [day (:day document)] (str day) "0"))
        quarter (atom (let [q (:quarter document)
                            m (:month document)
                            has-quarter (and q (pos? q))
                            no-month (or (nil? m) (zero? m))]
                        (if (and has-quarter no-month) (str q) "0")))

        assignments (atom (get-initial-ui-assignments (:document_collections document)))
        primary-collection-id-global (atom (:collection (first (filterv #(:main %) @assignments))))

        assignments-to-delete (atom #{})
        date-period (atom (if (not= @quarter "0") :quarter :month))
        set-today! (fn []
                     (let [current-time (time/now)]
                       (reset! year (time-core/year current-time))
                       (if (= @date-period :month)
                         (do
                           (reset! month (time-core/month current-time))
                           (reset! day (time-core/day current-time)))
                         (reset! quarter (inc (quot (dec (time-core/month current-time)) 3))))))
        form-width (atom nil)
        include-inactive-collections (atom false)
        prepare-submit-params (fn []
                                (let [{:keys [quarter month day]}
                                      (form/applies-to-date-parts @date-period
                                        {:quarter @quarter :month @month :day @day})]
                                  [(if (= :document @document-type) [@upload-id nil] [nil @body])
                                   quarter month day]))
        on-submit-handler (fn []
                            (prn "executing on submit handler")
                            (let [[[upload-id body]
                                   submit-quarter
                                   submit-month
                                   submit-day] (prepare-submit-params)]
                              (on-submit errors document
                              {:family-id @group
                               :collection-ids (get-collection-ids @assignments)
                               :category-id @category
                               :upload-id upload-id
                               :name @name
                               :ext-ref @ext-ref
                               :year @year
                               :month submit-month
                               :day submit-day
                               :quarter submit-quarter
                               :body body
                               :main-collection-id (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments)))})))
        _ (some-> register-submit-action-fn (apply [on-submit-handler]))]
    (when (:today options) (set-today!))

    (when-not (and (or allow-group-choice (not parent)) allow-collection-choice)
      (when collection
        (swap! assignments set-assignment 0
          {:collection     (str (:id collection))
           :collection-obj (collection-model/to-search-obj collection)})))

    (reagent/create-class {:reagent-render (fn [{:keys [initial-category-name on-submit]
                                                 :as options} collection document parent permitted-groups]
                             [:form.c-form--edit {:class (or (:form-class options) (when-not (:is-modal options) :o-media))
                                                  :on-submit (handler
                                                               (fn []
                                                                 (let [[[upload-id body]
                                                                        submit-quarter
                                                                        submit-month
                                                                        submit-day] (prepare-submit-params)]
                                                                   (if on-submit
                                                                     (on-submit-handler)
                                                                     #_(on-submit errors document
                                                                       {:family-id @group
                                                                        :collection-ids (get-collection-ids @assignments)
                                                                        :category-id @category
                                                                        :upload-id upload-id
                                                                        :name @name
                                                                        :ext-ref @ext-ref
                                                                        :year @year
                                                                        :month submit-month
                                                                        :day submit-day
                                                                        :quarter submit-quarter
                                                                        :body body
                                                                        :main-collection-id (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments)))})
                                                                     (document-submit
                                                                       {:success-cb (:success-cb options)}
                                                                       document errors
                                                                       parent
                                                                       @group
                                                                       (get-collection-ids @assignments)
                                                                       @category upload-id @name @ext-ref @year submit-month submit-day submit-quarter body
                                                                       (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments))))))))}

                              (when parent [:p.o-media--small (get-in @errors [:__meta__ :assignment :error-extra-component])])
                              (when (and (or allow-group-choice (not parent)) allow-collection-choice)
                                [:fieldset
                                 (when-not (:disable-headers options)
                                   [:legend "Ownership/Access"])

                                 (when allow-group-choice
                                   [:dl
                                    [:dt "Family"]
                                    [:dd [group-chooser permitted-groups group]]])

                                 (when-not parent
                                   ;; hidden but component rendered -- we want the initial collection to
                                   ;; be remembered as an assginent
                                   [:dl {:class (if allow-collection-choice "" "u-nodisplay")}
                                    [collection-field-header include-inactive-collections]
                                    [:dd [assignments-edit-notable-redesign {:include-inactive-atom include-inactive-collections} assignments errors collection assignments-to-delete group primary-collection-id-global]]])])

                              [:fieldset
                               (when-not (:disable-headers options)
                                 [:legend "Category & Custom Name"])
                               [:dl
                                [:dt "Document Category"]
                                [:dd [category-chooser
                                      (merge
                                        {:categories-loaded-cb (fn [categories]
                                                                 (when (and (not @category) initial-category-name)
                                                                   (when-let [cat (first (filter #(= (:name %) initial-category-name) categories))]
                                                                     (reset! category (:id cat)))))}
                                        (when document
                                          {:additional-categories [(:category document)]}))
                                      scope-atom category "d"] [:span.error (:category_id @errors "")]]]

                               [:dl
                                [:dt "Custom name"]
                                [:dd
                                 [:input.u-full-width {:type "text" :value @name :on-change (reset-from-event name)}]
                                 [:span.error (:name @errors "")]]]
                               (when-not (:disable-ext-ref options)
                                 [:dl
                                  [:dt "External Reference Number"]
                                  [:dd
                                   [:input {:type "text" :value @ext-ref :on-change (reset-from-event ext-ref)}]
                                   [:span.error (:ext_ref @errors "")]]])]

                              [:fieldset
                               (when-not (:disable-headers options) [:legend "Date"])
                               [:dl
                                [:dt "Applies to"]
                                [:dd
                                 [:div
                                  {:on-change (fn [e]
                                                (let [selected-date-period (-> e .-target .-value keyword)]
                                                  (reset! date-period selected-date-period)))}

                                  [:label [:input {:type "radio" :value :month :name "date" :checked (= @date-period :month) }] "Month"]
                                  [:label [:input {:type "radio" :value :quarter :name "date"  :checked (= @date-period :quarter) }] "Quarter"]]]


                                [:dd.o-margin-elements--md

                                 [:select.inline {:on-change (reset-from-event year)}
                                  [:option {:value "0"} "Choose year"]
                                  (doall (for [year-choice (form/year-choices)]
                                           [:option (form/set-selected @year year-choice {:key year-choice}) year-choice]))]

                                 (when (= @date-period :month)
                                   [:select {:on-change (reset-from-event month) :disabled (= "0" @year)
                                             :class (if (= "0" @quarter) "inline" "nodisplay")}
                                    [:option {:value "0"} "Choose month"]
                                    (doall (for [[number month-name] form/month-choices]
                                             [:option (form/set-selected number @month {:value number :key number}) month-name]))])

                                 (when (= @date-period :quarter)
                                   [:select {:on-change (reset-from-event quarter) :disabled (= "0" @year)
                                             :class (if (= "0" @month) "inline" "nodisplay")}
                                    [:option {:value "0"} "Choose quarter"]
                                    (doall (for [[number quarter-name] form/quarter-choices]
                                             [:option (form/set-selected number @quarter {:value number :key number}) quarter-name]))])

                                 (when (= @date-period :month)
                                   [:select {:on-change (reset-from-event day) :disabled (= "0" @month)
                                             :class "inline"}

                                    [:option {:value "0"} "Choose day"]
                                    (doall (for [number (form/day-choices (str->int @year) (or (str->int @month) 1))]
                                             [:option (form/set-selected number @day {:key number}) number]))])

                                 [:span.error (:year @errors "")]]
                                [:dd.u-margin-top--xs
                                 [:button {:on-click (util/handler set-today!)} "Today"]]]]

                              [:fieldset
                               (when (and (not document) (not (:payload-operation-id options)))
                                 (when-not (:disable-headers options) [:legend "File type"])
                                 [:div
                                  (when-not (:image options)
                                  [:dl
                                   [:dt
                                    [:label [:input {:type :checkbox
                                                     :on-change (fn [ev] (when (form/checked? ev) (reset! document-type :document)))
                                                     :checked (= @document-type :document)}] "Upload a document file"]

                                    [:label [:input {:type :checkbox
                                                     :on-change (fn [ev] (when (form/checked? ev) (reset! document-type :note)))
                                                     :checked (= @document-type :note)}] "Create text document"]]])

                                  (when (and (= @document-type :document) (not (:disable-upload options)))
                                    [:dl
                                     (when-not (:image options) [:dt "Choose or drag a file"])
                                     [:dd
                                      [upload options upload-id errors]
                                      [:span.error (:upload_id @errors "")]]])])

                               (when (= @document-type :note)
                                 [:dl.note-editor
                                  [:dt "Create/Edit a text document here"]
                                  [:dd.s-note-editor
                                   (when @form-width
                                     [editor {:text-change-cb (fn [_] (-> ($ ".ql-editor") (.width (* 0.85 @form-width))))} body])
                                   [:span.error (:upload_id @errors "")]]])]

                              (when-not (:disable-controls options)
                                [:footer.o-space-between
                                 (if-not (:disable-back options)
                                   (if-let [back-cb (:back-cb options)]
                                     [:button {:on-click back-cb} (or (:back-label options) "Close")]
                                     [:button {:on-click util/back} "Back"])
                                   [:div])

                                 [:div
                                  (:extra-controls options)
                                  [:button {:type "submit"} (or (:submit-label options ) "Save")]]])])

                           :component-did-mount (fn [_]
                                                  (reset! form-width (-> ($ ".c-form--edit fieldset") .width)))})))

(defn document-edit [collection document parent permitted-groups]
  (fn []
    [common/standalone-form-redesign
     [:div.u-shadow--bottom
      (if document
        [header
         :supertitle (collection-name (get-in document [:document_collections 0 :collection :ancestors 0]))
         :category (when-let [category (get-in document [:category])] (:type category))
         :aside-title "document"
         :title (document-complex-name document)
         :aside-subtitles (list ["Created" (when-let [date (get-in document [:created_at])] (util/date-reformat date))]
                                ["Modified" (when-let [date (get-in document [:updated_at])] (util/date-reformat date))])]

        [header
         :title [:span "Add a new document" (if collection [:span " to " (collection-name collection)] "")]
         :simple? true])

      [document-edit-form {} collection document parent permitted-groups]]]))

(defn document-submit [{success-cb :success-cb} document errors parent & form-data]
  (let [submit-func (if document (partial model/document-update (:id document)) model/document-add)]
    (->> (apply submit-func (link-model/parent-params parent) form-data)
         (p/map (fn [{document-collections :document_collections
                      :as response}]
                  (if success-cb
                    (success-cb response)
                    (do
                      (set-flash :success "Document saved")
                      (if (get-in response [:perms :can_view])
                        (util/set-location (str "#/document/details/" (:id response)))
                        (when parent
                          (util/set-location (link/parent-info-url parent))))))))
         (p/error (fn [response]
                    (handle-error-response errors response)
                    (throw response)))
         (p/error (fn []
                    (when-let [doc (get-in @errors [:__meta__ :assignment :document])]
                      (swap! errors assoc-in [:__meta__ :assignment :error-extra-component]
                             [:div.error "Duplicate Document detected at " [:a {:href (path-for :document-details
                                                                                                           :id (:id doc))
                                                                                :target :_blank}
                                                                            (pfo.common.model/document-complex-name doc)]])))))))

(defn upload [options upload-id-atom errors-atom]
  [:> ReactDropzone
   {:config
    {:iconFileTypes [".jpg" ".png" ".gif"]
     :showFileTypeIcon true
     :postUrl (api/api-url "/file/upload/")}
    :djsConfig (merge
                 {:maxFiles 1
                  ;; 60 min timeout
                  :timeout 3600000
                  :maxFilesize 2048
                  :paramName "file"
                  :headers (api/auth-headers)
                  :addRemoveLinks true}
                 (when (:image options)
                   {:acceptedFiles "image/*"
                    :dictDefaultMessage "Choose an image to upload or drop it here"}))
    :eventHandlers {:init (fn [^js dzone]
                            (.on dzone "maxfilesexceeded"
                              (fn [file]
                                (.removeFile dzone file)))
                            (.on dzone "removedfile"
                              (fn [file]
                                ;; TODO: actually remove file from the server
                                (reset! upload-id-atom nil))))
                    :error (fn [e] (when (= "error" (.-status e))
                                     (swap! errors-atom assoc
                                       :upload_id
                                       "Upload failed. Try again later.")))
                    :success (fn [e response]
                               (swap! errors-atom assoc :upload_id nil)
                               (reset! upload-id-atom (.-id response)))
                    :thumbnail (fn [file dataURL]
                                 ;; Don't attempt to preview HEIC thumbnail
                                 (when (= "image/heic" (.-type file))
                                   (-> (js/$ "div.dz-image img") (.removeAttr "src"))
                                   (-> (js/$ "div.dz-preview") (.addClass "dz-file-preview"))))}}])

(defn pdf-placeholder []
  [:div.c-document__preview.is-note "Loading preview..."])

;; An SVG keeps its image icon but gets no preview: the server refuses to serve one as an
;; image (sec#141), so the <img> would only show as broken.
(defn is-image [document]
  (and (not= "svg" (:extension document))
       (= "image" (document-icon-classes (:extension document)))))

(defn is-document-within-edit-window [document]
  (is-now-within-window (util/parse-datetime (:created_at document)) document-max-manage-age))

(defn confirm-regenerate-summary-modal [document-id user-name date]
  [:div.c-confirm-regenerate-summary-modal
   [:p.u-margin-top.u-margin-bottom
    (str "Generate a new summary to review. The existing summary from "
         user-name " on " date " won't be replaced unless you choose to save.")]
   [:footer.o-space-between
    [:button.c-button--wide.c-button--outlined
     {:type :button
      :on-click (util/handler #(common/hide-modal :confirm-regenerate-summary))}
     "Cancel"]
    [:button.c-button--wide
     {:type :button
      :on-click (util/handler
                  (fn []
                    (common/hide-modal :confirm-regenerate-summary)
                    (controller/dispatch :document-generate-summary :generate
                      {:document-id document-id})))}
     "Generate & Review"]]])

(defn confirm-regenerate-summary [document summary]
  (let [user-name (auth-model/get-full-name (:created_user summary))
        date      (util/date-reformat (:created_at summary))]
    (common/show-modal :confirm-regenerate-summary
      [confirm-regenerate-summary-modal (:id document) user-name date]
      {:modal-class "c-confirm-regenerate-summary-modal-wrapper"})))

(defn- document-help-content []
  [:<>
   [:p [:strong "Summarize / Regenerate Summary:"] " Generates an AARK™ summary of the document. The button reads \"Regenerate\" if a summary already exists (yours or another user's); view the current one under the Summary tab."]
   [:ul
    [:li "Add focus areas or formatting instructions before generating"]
    [:li "Preview before saving — a regenerated summary only replaces the existing one if you save"]
    [:li "To revise after generating, cancel and tell AARK™ what to change"]]
   [:p [:strong "Ask a Question:"] " Opens AARK™ chat with this document in focus. Anyone with view access can ask. Only saved to your chat history."]])

(defn document-details [options document]
  (let [elem-node (atom nil)
        delete-prevention-delete-ability (common-model/delete-prevention-delete-ability (atom nil) document)
        conversations (atom nil)
        notify-user-choices (atom nil)
        document-linked-items (atom nil)
        is-user-document-creator #(= (api/get-auth-info :user-id) (get-in document [:created_user :id]))
        edit-ability (cond
                       (get-in document [:perms :can_modify]) (atom :edit)
                       (and (is-user-document-creator) (get-in document [:perms :can_add])) (util/self-updating-atom #(when (is-document-within-edit-window document) :edit-with-timer))
                       :else (atom nil))
        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users {:document-view true} collection-ids)
                          (p/map (fn [response]
                                   (reset! notify-user-choices response)))
                          (process-error)))
        load-linked-items (fn []
                            (->> (link-model/document-links (:id document))
                                 (p/map #(reset! document-linked-items %))
                                 (process-error)))
        comments-summary (atom nil)
        comment-count (atom (get-in document [:counters :comment_count]))
        linked-list-collapsed? (atom false)
        active-tab (atom :preview)
        is-document-signed? (= (get-in document [:signature_info :status]) model/signature-status-completed)
        load-comments-summary (fn []
                                (->> (model/document-comments-summary (:id document))
                                     (p/map (fn [response] (reset! comments-summary (response (keyword (str (:id document)))))))
                                     (process-error)))
        summary (atom nil)
        load-summary (fn []
                       (->> (model/document-summary (:id document))
                            (p/map #(reset! summary %))
                            (process-error)))
        aark-enabled? (collection-model/has-aark-enabled
                        (get-in document [:document_collections 0 :collection :ancestors 0 :id]))]

    (add-watch document-linked-items :document-linked-items-watch (fn [_ _ _ new-document-linked-items]
                                                                    (swap! linked-list-collapsed? (fn [x] (if (> (link/linked-items-counter new-document-linked-items nil false) 10) true false)))))
    (add-watch active-tab :summary-tab-watch (fn [_ _ _ new-tab]
                                               (when (= new-tab :summary)
                                                 (load-summary))))
    (load-linked-items)
    (load-comments-summary)
    (load-summary)
    (load-users (mapv (fn [dc] (:collection_id dc)) (:document_collections document)))
    (reagent/create-class
      {:reagent-render (fn []
                         (let [document-url (str "/download/documents/")]
                           [:div.c-document.redesign.u-shadow--bottom {:ref #(reset! elem-node %)}
                            [header
                             :supertitle (collection-name (get-in document [:document_collections 0 :collection :ancestors 0]))
                             :category (when-let [category (get-in document [:category :type])] category)
                             :title (document-complex-name document)
                             :show-aside? true
                             :aside-title "document"
                             :aside-subtitles (list ["Created" (when-let [date (get-in document [:created_at])] (util/date-reformat date))]
                                                    ["Modified" (when-let [date (get-in document [:updated_at])] (util/date-reformat date))])

                             :controls [:div.row
                                        [:div.edit.u-flex.u-align-items--center
                                         [countdown-for-ability nil (util/parse-datetime (:created_at document)) document-max-manage-age
                                          edit-ability delete-prevention-delete-ability]
                                         (when @edit-ability
                                           [:img.svg-icon--md.u-cursor--pointer
                                            {:src "/static/img/icons/edit.svg"
                                             :title "Edit"
                                             :on-click #(set-location (str "#/document/edit/" (:id document)))}])
                                         (when @delete-prevention-delete-ability
                                           (perm :can_delete document
                                             [:img.svg-icon--md.u-cursor--pointer
                                              {:src "/static/img/icons/delete.svg"
                                               :title "Delete document"
                                               :on-click (fn [ev]
                                                           (when (js/confirm "Are you sure you want to delete this document?")
                                                             (do ((->> (model/document-delete (:id document))
                                                                    (p/map (fn [_]
                                                                             (set-flash :success "Document deleted")
                                                                             (util/back ev)))
                                                                    (process-error))))))}]))
                                         (when (and aark-enabled?
                                                    (= (model/document-type document) :document)
                                                    (get-in document [:perms :can_modify]))
                                           [:button.c-button--aark {:on-click (fn [_]
                                                                     (if (seq @summary)
                                                                       (confirm-regenerate-summary document @summary)
                                                                       (controller/dispatch :document-generate-summary :generate
                                                                         {:document-id (:id document)})))}
                                            [:img {:src "/static/img/icons/summarize-icon.svg"}]
                                            (if (seq @summary) "Regenerate summary" "Summarize")])
                                         (when (and aark-enabled?
                                                    (= (model/document-type document) :document)
                                                    (get-in document [:perms :can_view]))
                                           [:button.c-button--aark {:on-click (fn [_]
                                             (controller/dispatch :document-ask-question :start
                                               {:document-id (:id document)}))} "Ask a Question"])
                                         (when (and aark-enabled?
                                                    (= (model/document-type document) :document)
                                                    (get-in document [:perms :can_modify]))
                                           [help-popover [document-help-content] {:align :right :size :s :wide true}])]]

                             :options {:date-uploaded? (= :document (model/document-type document))}]

                            [:div.o-media--bottom-shadow-1
                             [assignment-list-with-header {:hide-expander true} (:document_collections document)]]

                            [:div.o-main-aside
                             [:div.o-media--around-shadow.o-main-aside__aside--large.c-document__preview-container.u-shadow--bottom
                              (when (and (= (model/document-type document) :document)
                                         (or aark-enabled? (seq @summary)))
                                [:div.c-document__tabs
                                 [:ul.o-tabs-and-content__tabs
                                  [tab-header {:tab-id :preview :active-atom active-tab} "Preview"]
                                  [tab-header {:tab-id :summary :active-atom active-tab} "Summary"]]])
                              (when (= @active-tab :preview)
                                [:div
                                 [:div.c-document__summary-header
                                  [:div.c-document__main-details

                                   [:p [:b "Number: "] [:span (:id document)]]

                                   (when (not-empty (:extension document))
                                     [:p [:b "Document Ext: "] [:span (:extension document)]])

                                   (when-let [ext-ref (not-empty (:ext_ref document))]
                                     [:p [:b "External Reference Number: "] [:span ext-ref]])
                                   (when is-document-signed?
                                     [:div.u-flex
                                      [:p [:b (model/signature-providers (get-in document [:signature_info :provider])) ": "]
                                       "Signed on: " [:span (-> (get-in document [:signature_info :updated_at]) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]]
                                      [:div {:style {:margin-left "0.5em"}}
                                       [:form {:method :post
                                               :action (str "/download/documents/signature/audit/")}
                                        [:input {:type :hidden
                                                 :name :key
                                                 :value (:download_key document)}]
                                        [:input {:type :hidden
                                                 :name :btn
                                                 :value "1"}]
                                        [:button.c-button--small "Audit File"]]]])
                                   [:p
                                    [:b (if (= :document (model/document-type document)) "Uploaded By: " "Created By: ")]
                                    [:span (auth-model/get-full-name (:created_user document))]]]

                                  [:div.u-flex.u-align-items--center
                                  (when (= (model/document-type document) :document)
                                    [:form {:method :post
                                            :target "_blank"
                                            :action document-url}
                                     [:input {:type :hidden
                                              :name :key
                                              :value (:download_key document)}]
                                     [:input {:type :hidden
                                              :name :attachment
                                              :value "no"}]
                                     [:button "Open"]]) " "
                                  [:form {:method :post
                                          :action document-url}
                                   [:input {:type :hidden
                                            :name :key
                                            :value (:download_key document)}]
                                   [:input {:type :hidden
                                            :name :btn
                                            :value "1"}]
                                   (when (= :document (model/document-type document))
                                     [:input {:type :image
                                              :src "/static/img/icons/download.svg"
                                              :title "Download"}])
                                   (when (= :boir (model/document-type document))
                                     [:button "Download as XML"])
                                   (when (contains? #{:note :boir} (model/document-type document))
                                     [:button {:name "pdf" :value "1"} "Download as PDF"])]]]
                                 (if (not= :note (model/document-type document))
                                   [:div.c-document__preview
                                    (cond
                                      (or
                                        (:is_pdf document)
                                        (= :boir (model/document-type document)))
                                      [:div
                                       [pdf-view {:on-click (util/handler #(reset!
                                                                             state/document-preview-modal
                                                                             {:enabled true
                                                                              :pdf-location {:url document-url
                                                                                             :key (:download_key document)}
                                                                              :title (document-complex-name document)}))
                                                  :pdf-location {:url document-url
                                                                 :key (:download_key document)}
                                                  :placeholder pdf-placeholder}]]
                                      (is-image document) [:div.c-document__preview [image-view document-url (:download_key document) {:attachment :no}]]

                                      :else [:div.c-document__preview.is-note "Preview not available"])]
                                   (util/html-elem :div.ql-editor.c-document__preview.is-note.c-string-field
                                     (util/html-break-text (:body document))))])
                              (when (= @active-tab :summary)
                                [:div.c-document__summary
                                 (if (seq @summary)
                                   [:<>
                                    [:div.c-document__summary-header
                                     [:div.c-document__main-details
                                      [:p [:b "Generated on: "] [:span (util/date-reformat (:created_at @summary))]]
                                      [:p [:b "Generated by: "] [:span (auth-model/get-full-name (:created_user @summary))]]]
                                     [:div.u-flex.u-align-items--center
                                      (when (and aark-enabled? (get-in document [:perms :can_modify]))
                                        [:button.c-button--aark {:on-click (fn [_]
                                                                   (confirm-regenerate-summary document @summary))}
                                         [:img {:src "/static/img/icons/summarize-icon.svg"}]
                                         "Regenerate summary"])
                                      [common/pdf-download-button {:ajax-url (str "/documents/" (:id document) "/summary/download/")
                                                                       :component :a.c-icon--auto}
                                       [:img {:src "/static/img/icons/download.svg" :title "Download summary"}]]]]
                                    [:div.c-document__summary-body
                                     [:div.c-document__summary-title (:name document)]
                                     [chat-common/markdown-message nil (:body @summary)]
                                     [:p.c-document__summary-disclaimer "AARK™ is AI and can make mistakes. This summary is provided for informational purposes only. It does not constitute legal, financial, or professional advice."]]]
                                   [:<>
                                    [:p.u-margin-bottom--small "No document summary currently exists. Click the \"Summarize\" button to generate one."]
                                    (when (and aark-enabled? (get-in document [:perms :can_modify]))
                                      [:button.c-button--aark {:on-click (fn [_]
                                                                 (controller/dispatch :document-generate-summary :generate
                                                                   {:document-id (:id document)}))}
                                       [:img {:src "/static/img/icons/summarize-icon.svg"}]
                                       "Summarize"])])])]

                            [:main.o-media--bottom-shadow
                             [:h4.c-heading--no-top-border.o-margin-elements--md [:span "Related Records " (link/linked-items-counter @document-linked-items nil true)]
                              [link/link-add-chooser {:initial-collection-id (:collection_id (first (:document_collections document)))
                                                      :parent {:type (if (= :document (model/document-type document)) link/type-document link/type-note)
                                                               :id (:id document)}

                                                      :parent-collection-ids (mapv #(:collection_id %) (:document_collections document))
                                                      :linked-items-documents-download [link/linked-items-documents-download-form (:download_key @document-linked-items)]}]]

                             [link/linked-items {} [(link/link-map-entry
                                                           {:parent-type (:doc_type document)
                                                            :parent-id (:id document)
                                                            :reload load-linked-items}
                                                           (:children @document-linked-items))
                                                          (link/link-map-entry {:items-type "parent"} (:parents @document-linked-items))]]]]

                            [:footer.o-media
                             (let [comment-errors (atom {})]
                               [comment-comp/expandable-conversation-list
                                {:highlight-comment-id (:highlight-comment-id options)
                                 :users @notify-user-choices
                                 :user-perms (:perms document)
                                 :rich-text true
                                 :errors-atom comment-errors
                                 :comment-count comment-count
                                 :reload-cb load-comments-summary
                                 :add-func (fn [conversation conversation-id note subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply revised-comment-id]
                                             (model/document-add-comment
                                               (:id document)
                                               conversation-id
                                               note
                                               subject
                                               body
                                               notify-user-ids
                                               notify-cc-user-ids
                                               include-body
                                               allow-inbox-reply
                                               revised-comment-id))
                                 :update-func (fn [comment-id subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply]
                                                (model/document-update-comment
                                                  (:id document)
                                                  comment-id
                                                  subject
                                                  body
                                                  notify-user-ids
                                                  notify-cc-user-ids
                                                  include-body
                                                  allow-inbox-reply))
                                 :delete-func (fn [comment-id notify-user-ids]
                                                (model/document-delete-comment
                                                  (:id document)
                                                  comment-id
                                                  notify-user-ids))}
                                (fn [] (model/document-comments (:id document)))])]]))
       :component-did-mount (fn [_])
       :component-will-unmount (fn [_]
                                 (util/stop-self-updating! edit-ability)
                                 (util/stop-self-updating! delete-prevention-delete-ability))})))

(defn document-preview-modal []
  [modal [:div
          [:h1 (:title @state/document-preview-modal)]
          [pdf-view {:pdf-location (:pdf-location @state/document-preview-modal)
                     :multi-page true
                     :placeholder pdf-placeholder}]]
   state/document-preview-modal])

(defn document-filter [_ filter-params filter-show]
  (let [filter-collection-id (l/derive (l/key :collection-id) filter-params)
        filter-include-subcollections (l/derive (l/key :include-subcollections) filter-params)
        filter-include-linked-to-other-parents (l/derive (l/key :include-linked-to-other-parents) filter-params)
        filter-period (l/derive (l/key :period) filter-params)
        filter-collection-types (l/derive (l/key :collection-types) filter-params)
        filter-categories (l/derive (l/key :categories) filter-params)
        filter-creator-users (l/derive (l/key :creator-users) filter-params)
        filter-created-at-period (l/derive (l/key :created-at-period) filter-params)
        filter-choices (subscribe :document-filter-choices)
        quarters (track! #(:quarters @filter-choices))
        categories (track! #(:categories @filter-choices))
        creator-users (track! #(:creator_users @filter-choices))
        collection-types (track! #(:collection_types @filter-choices))
        dates (track! #(time/transform-date-ranges (:created_at_ranges @filter-choices)))
        load-filter-data (fn []
                           (controller/dispatch
                            :document-filter-choices :load
                            [{:collection-ids @filter-collection-id
                              :include-subcollections @filter-include-subcollections}]))
        collapsed-default (not (mobile?))
        collapsed? (atom {:collection collapsed-default
                          :collection-type collapsed-default
                          :category collapsed-default
                          :user collapsed-default
                          :date collapsed-default
                          :created collapsed-default})
        toggle-collapsed (fn [key]
                           (swap! collapsed? assoc key (not (get @collapsed? key))))
        collapsed-all? (atom true)
        toggle-collapsed-all (fn [value]
                               (swap! collapsed? (fn [c-map]
                                                   (zipmap (keys c-map) (repeat value)))))
        clear-trigger (atom false)
        clear-all (fn []
                    (swap! filter-params merge
                      {:categories #{},
                       :categories-exclude nil,
                       :collection-types #{},
                       :collection-types-exclude nil,
                       :created-at-period nil,
                       :created-at-period-exclude nil,
                       :creator-users #{},
                       :creator-users-exclude nil,
                       :include-linked-to-other-parents nil,
                       :include-subcollections true,
                       :period nil,
                       :period-exclude nil})
                    (swap! clear-trigger not))]
    (load-filter-data)
    (add-watch filter-collection-id :filter-collection-id-document-filter #(when true #_@watches-enabled-atom (load-filter-data)))
    (add-watch filter-include-subcollections :include-subcollections-document-filter #(when true #_@watches-enabled-atom (load-filter-data)))

    (fn [options & _]
      [sidebar-rounded
       [:div.o-media--margin {:class (when (common/mobile?) :mobile)}
        [:div.filter-top
         [common/filter-top filter-show clear-all toggle-collapsed-all collapsed-all?]
         (when (and (:show-include-subcollections options) @filter-collection-id)
           [:label [:input.include-subcollections
                    (form/set-checked
                     @filter-include-subcollections
                     {:type "checkbox"
                      :on-change (fn [ev] (swap! filter-include-subcollections not))})]
            "Subcollections"])]
        (when (:has-parent-filtering options)
          [:label [:input.include-subcollections
                   (form/set-checked
                    @filter-include-linked-to-other-parents
                    {:type "checkbox"
                     :on-change (fn [ev] (swap! filter-include-linked-to-other-parents not))})]
           "Include all documents that have already been linked in another step/occurrence of this compliance."])

        (when (:show-collection-filter options)
          [:div.filter-item [nested-select filter-collection-id {:initial-id @filter-collection-id
                                                                 :top-id (:collection-top-ancestor-id options)
                                                                 :limit-ancestors true
                                                                 :label "Collection"
                                                                 :children-loader collection-model/collection-list-promise
                                                                 :ancestors-loader collection-model/collection-ancestors
                                                                 :sizer default-select-sizer
                                                                 :clear true
                                                                 :collapsed (:collection @collapsed?)
                                                                 :collapse-fn (fn []
                                                                                (toggle-collapsed :collection))
                                                                 :clear-trigger clear-trigger}]])
        [common/category-filter
         {:extra-option [filter-exclude {:disabled (not (seq @filter-categories))} (l/derive (l/key :categories-exclude) filter-params)]
          :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :category)}]
          :collapsed (:category @collapsed?)
          :clear true}
         categories filter-categories]
        [:div.date-filter 
         [common/date-filter 
          {:extra-option [filter-exclude {:disabled (not @filter-period)} (l/derive (l/key :period-exclude) filter-params)]
           :collapsed (:date @collapsed?)
           :collapse-fn (fn []
                          (toggle-collapsed :date))} quarters filter-period]]
        [common/collection-type-filter
         {:extra-option [filter-exclude {:disabled (not (seq @filter-collection-types))} (l/derive (l/key :collection-types-exclude) filter-params)]
          :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :collection-type)}]
          :collapsed (:collection-type @collapsed?)
          :clear true}
         collection-types filter-collection-types]
        (when (enabled "filter-enhancements")
          (when (seq @creator-users)
            (common/user-filter
             {:extra-option [filter-exclude {:disabled (not (seq @filter-creator-users))} (l/derive (l/key :creator-users-exclude) filter-params)]
              :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :user)}]
              :collapsed (:user @collapsed?)
              :clear true}
             creator-users filter-creator-users "Uploaded By")))

        (when (enabled "filter-enhancements")
          [:div.date-filter
           [common/date-day-filter
            {:label "Date Uploaded"
             :extra-option [filter-exclude {:disabled (empty? @filter-created-at-period)} (l/derive (l/key :created-at-period-exclude) filter-params)]
             :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :created)}]
             :collapsed (:created @collapsed?)
             :clear true}
            @dates filter-created-at-period]])]])))

(defn document-add-or-choose [options parent permitted-groups]
  (let [choose-existing (atom false)
        choose-errors (atom nil)]
    (fn []
      [common/standalone-form-redesign
       [:div.c-document-add-or-choose
        [:header {:class (when-not (:is-modal options) "c-header")}
          [:h2 (if (:image options) "Add an image" "Add a document") (when-let [object (:object parent)]
                                   (str " from "
                                        (get-in object [:collections 0 :name]) ", "
                                        (case (get-in object [:linked_object :object_type])
                                          ("to" "eo") (if (get-in object [:linked_object :task :group :multi_step])
                                                        (str "Step " (get-in object [:linked_object :step_idx]) " - " (task-model/strip-step-prefix (get-in object [:linked_object :task :name])))
                                                        (get-in object [:linked_object :task :name]))
                                          "t" (get-in object [:linked_object :group :name])
                                          "d" (get-in object [:linked_object :complex_name])
                                          (get-in object [:linked_object :name]))))]
          [:aside
            [:b [:label [:input (form/set-checked (not @choose-existing) {:on-change #(swap! choose-existing not)})] "Add new"]] " "
            [:b [:label [:input (form/set-checked @choose-existing {:on-change #(swap! choose-existing not)})] "Choose existing"]]]]

        [:div {:class (when-not (:is-modal options) "standalone-form-redesign__list-or-form u-shadow--bottom ")}
          (if @choose-existing
            [document-list (merge {:choose true
                                  :choose-collection-ids (or (:parent-collection-ids parent) (get-in options [:collection :id]))
                                  :choose-cb (fn [documents filter-params select-all]
                                               (let [document-ids (mapv #(:id %) documents)]
                                                 (->> (model/add-link filter-params
                                                        (:parent-type parent)
                                                        (:parent-id parent)
                                                        (:complete-by parent)
                                                        link/type-document
                                                        document-ids
                                                        select-all)
                                                      (p/map (fn [response] (.go js/history -1)))
                                                      (process-error choose-errors))))
                                  :choose-parent parent
                                  :choice-changed-cb #(reset! choose-errors nil)
                                  :choose-extra-component (when (seq @choose-errors)
                                                            [:p.o-media--small.error (:child_id @choose-errors)])}
                                  options)]
            [(if (:is-modal options) :div.regular-form common/standalone-form-redesign)
             [:div
               [document-edit-form options (:collection options) nil parent permitted-groups]]])]]])))

(defn document-add-modal []
  [modal
   [document-add-or-choose
    {:disable-collection-choice true
     :no-include-subcollections true
     :is-modal true
     :image (:image @state/document-add-modal)
     :collection-assignable-only (:collection-assignable-only @state/document-add-modal)
     :allow-subcollections (not (:collection-assignable-only @state/document-add-modal))
     :current (:current @state/document-add-modal)
     :deleted (:deleted @state/document-add-modal)
     :paginate (:paginate @state/document-add-modal)
     :success-cb (fn [document]
                   ((:success-cb @state/document-add-modal) (with-complex-names [document])))
     :back-cb (:back-cb @state/document-add-modal)
     :collection (:collection @state/document-add-modal)
     :choose-cb (fn [documents filter-params select-all]
                  ((:success-cb @state/document-add-modal) (with-complex-names documents) filter-params select-all))
     :single-document (:single-document @state/document-add-modal)}
    nil
    (:permitted-groups @state/document-add-modal)]
   state/document-add-modal])

(defn signature-wait []
  [header-tab-wrapper
   "Documents signature"
   [:div.o-media "Please wait while the signature is being prepared."]])
